/* Canvono baked color->hex table (window.CVN_HEX).
 * One representative hex per distinct Color option value across every blank.
 * Used by cvn-filter.js famOf() for hex-primary color-family classification.
 * Regenerate from products' custom.color_identity metafields when the palette changes. */
window.CVN_HEX = {
  "Natural": "#FEF1D1",
  "Soft Cream": "#E7D4C0",
  "Heather Natural": "#F9E9CF",
  "Tan": "#DDB792",
  "Heather Dust": "#E5D9C9",
  "White": "#FFFFFF",
  "Ash": "#F0F1EA",
  "Sage": "#9EAB96",
  "Silver": "#E3E3DD",
  "Athletic Heather": "#CECECC",
  "Heather Prism Dusty Blue": "#A5C8BC",
  "Vintage White": "#FCF4E8",
  "Light Blue": "#CFD5E1",
  "Baby Blue": "#C7D7EF",
  "Heather Prism Mint": "#AAD5B9",
  "Soft Pink": "#FFD8E1",
  "Heather Prism Lilac": "#DEAFCD",
  "Toast": "#CF8D4C",
  "Heather Mint": "#B2EBCF",
  "Heather Prism Peach": "#F3C2B2",
  "Pink": "#FDBFC7",
  "Lilac": "#EFBBE3",
  "Forest": "#223E25",
  "Heather Forest": "#425040",
  "Black": "#0C0C0C",
  "Navy": "#212642",
  "Heather Emerald": "#1E2C1C",
  "Brown": "#322622",
  "Maroon": "#721D37",
  "Olive": "#5B642F",
  "Heather Navy": "#303643",
  "Army": "#5F5849",
  "Heather Olive": "#5C5531",
  "Military Green": "#4D4C36",
  "Asphalt": "#52514F",
  "Oxblood Black": "#2C1013",
  "Team Purple": "#230F46",
  "Heather Midnight Navy": "#302D4B",
  "Dark Grey": "#2A2929",
  "Dark Grey Heather": "#3E3C3D",
  "Vintage Black": "#151515",
  "Black Heather": "#0B0B0B",
  "Cardinal": "#890C1E",
  "Sand": "#E7D3B3",
  "Sport Grey": "#CCCCCE",
  "Carolina Blue": "#8DB7F6",
  "Heather Deep Royal": "#6898F2",
  "Light Pink": "#F3D4E3",
  "Gold": "#FFAF24",
  "Forest Green": "#1A3626",
  "Dark Chocolate": "#35241B",
  "Purple": "#4A1C7D",
  "Indigo Blue": "#395D82",
  "Charcoal": "#534E4A",
  "Dark Heather": "#46484D",
  "Graphite Heather": "#686868",
  "True Royal": "#2E4DB0",
  "Oyster": "#EDCEA5",
  "Light Grey": "#BFC1C2",
  "Classic Pink": "#FFBFD9",
  "Mint": "#6EF9E0",
  "Burgundy": "#491729",
  "Bottle Green": "#05442F",
  "French Navy": "#0D151C",
  "Coral": "#FF5A4E",
  "Mustard": "#D39E22",
  "Orange": "#F95200",
  "Red": "#DA0A1A",
  "Yellow": "#FFD667",
  "Heather Yellow Gold": "#FFB834",
  "Heather Prism Ice Blue": "#C3E2E3",
  "Heather Deep Teal": "#447085",
  "Heliconia": "#DB3E79"
};
